/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Pipe to allow AEM insert styles to template components
 * @access private
 * @TODO log when this is used
 */
@Pipe({
  name: 'safeStyle',
})
export class SafeStylePipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}

  public transform(value: string): SafeHtml {
    if (value) {
      return this.sanitized.bypassSecurityTrustStyle(value);
    } else {
      return value;
    }
  }
}
